import Header from './components/header/Header';
import Keyboard from './components/keyboard/Keyboard'
import './App.css'

export default function Scrynth() {
  
  return <>
    <Header />
    <Keyboard />
  </>
}